export default {
  data() {
    return {
      datepickerMenu: false,
      activePicker: null
    };
  },
  watch: {
    datepickerMenu(val) {
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    }
  },
  computed: {
    datepickerWidth() {
      switch (this.activePicker) {
        case 'YEAR':
          return 100;
        case 'MONTH':
          return 286;
        case 'DATE':
          return 370;
        default:
          return 290;
      }
    }
  },
  methods: {
    formatMonth(yearMonth) {
      const [year, month] = yearMonth.split('-').map(part => parseInt(part));
      return new Intl.DateTimeFormat(this.$i18n.locale, { month: 'long' }).format(
        new Date(year, month - 1)
      );
    },
    formatWeekday(date) {
      const [year, month, day] = date.split('-').map(part => parseInt(part));
      return new Intl.DateTimeFormat(this.$i18n.locale, { weekday: 'short' }).format(
        new Date(year, month - 1, day)
      );
    },
    formatDate(date) {
      if (!date) {
        return null;
      }
      if (date.indexOf('.') !== -1) {
        return date;
      }
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    getLocalizedDatePart(date, part, requiredFormat = null) {
      let format = requiredFormat;

      if (!format) {
        switch (part) {
          case 'month':
            format = 'long';
            break;
          case 'weekday':
            format = 'short';
            break;
          case 'minute':
            format = '2-digit';
            break;
          default:
            format = 'numeric';
        }
      }

      const formatter = Intl.DateTimeFormat(this.$i18n.locale, {
        [part]: format
      });
      const localizedParts = formatter.formatToParts(date);
      return localizedParts.find(lp => lp.type === part).value;
    }
  }
};
